import React from 'react';

import { StrokePatternsPaletteContext } from '@neptune/stroke-patterns-domain';

export function useStrokePatternsPaletteContext() {
  return React.useContext(StrokePatternsPaletteContext);
}
